
const withAuth = (WrappedComponent: any) => {
    return (props: any) => {
        const accessToken = sessionStorage.getItem("token");
        if (!accessToken) {
            window.location.replace("login");
            return null;
        }
        return <WrappedComponent {...props} />
    }
}

export default withAuth;